<template>
	<div :class="`app-${quizProgress}${matchup ? ' d-flex flex-column' : ''}`" class="d-flex flex-column" :key="quizProgress">
		<transition name="fade" mode="out-in" appear>
			<div v-if="$slots.default">
				<slot />
			</div>
		</transition>
		<ProgressBarContainer v-if="matchup" class="mx-2 mx-md-0">
			<template #bar>
				<b-progress
					:value="quizProgress"
					:max="barMax"
					v-if="quizProgress"
					height="0.5rem"
					variant="primary"
					class="rounded"
				></b-progress>
			</template>
		</ProgressBarContainer>
	</div>
</template>
<script>
import { mapState } from "vuex"
import ProgressBarContainer from "@/components/ProgressBarContainer.vue"

export default {
	name: "Matchup-Layout",
	components: {
		ProgressBarContainer
	},
	data() {
		return {}
	},
	computed: {
		...mapState({
			project: (state) => state.api.currentProject,
			quizProgress: (state) => state.api.quizProgress,
			projectSequences: (state) => state.api.projectSequences,
			matchup: (state) => state.api.currentMatchup,
			countRandomMatchups: (state) => state.api.countRandomIdealMatchups,
		}),

		barMax() {
			return this.calcBarMax()
		},
	},

	methods: {
		calcBarMax: function () {
			if (this.project.sequences) {
				if (this.project.custom_order) {
					return this.matchup.sequence.sequence_length
				} else {
					return this.countRandomMatchups
				}
			} else {
				return this.project.questions_sequence
			}
		},
	},
}
</script>
